import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Checkbox, TextField } from "@mui/material";
import { Check, ChevronDown, HardDriveUploadIcon, Plus } from "lucide-react";
import { useFetchCustomerCitiesQuery } from "../../../../services/baseQuery";

const CategoryHeader = ({ onFilterChange, filters }) => {
  const handleFilterChange = (field, value) => {
    const newFilters = { ...filters, [field]: value };
    onFilterChange?.(newFilters);
  };

  // Get cities data
  const { data: citiesData, isLoading: isLoadingCities } =
    useFetchCustomerCitiesQuery();

  return (
    <div className="flex items-center gap-4 flex-wrap">
      {/* Store Type Filter */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Store Type</InputLabel>
        <Select
          value={filters.storeType}
          label="Store Type"
          onChange={e => handleFilterChange("storeType", e.target.value)}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E5E7EB",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5652B0",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5652B0",
            },
          }}>
          <MenuItem value="">All</MenuItem>
          <MenuItem value="WHOLESALER">Wholesaler</MenuItem>
          <MenuItem value="RETAILER">Retailer</MenuItem>
        </Select>
      </FormControl>

      {/* Status Filter */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Status</InputLabel>
        <Select
          value={filters.status}
          label="Status"
          onChange={e => handleFilterChange("status", e.target.value)}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E5E7EB",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5652B0",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5652B0",
            },
          }}>
          <MenuItem value="">All</MenuItem>
          <MenuItem value="active">Active</MenuItem>
          <MenuItem value="inactive">Inactive</MenuItem>
        </Select>
      </FormControl>

      {/* City Filter */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>City</InputLabel>
        <Select
          value={filters.city}
          label="City"
          onChange={e => handleFilterChange("city", e.target.value)}
          disabled={isLoadingCities}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E5E7EB",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5652B0",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5652B0",
            },
          }}>
          <MenuItem value="">All Cities</MenuItem>
          {citiesData?.data?.cities?.map(city => (
            <MenuItem key={city} value={city}>
              {city}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Credit Limit Filter */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Credit Limit</InputLabel>
        <Select
          value={filters.creditLimit}
          label="Credit Limit"
          onChange={e => handleFilterChange("creditLimit", e.target.value)}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E5E7EB",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5652B0",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5652B0",
            },
          }}>
          <MenuItem value="">All</MenuItem>
          <MenuItem value="0-100000">₹0 - ₹100,000</MenuItem>
          <MenuItem value="100000-500000">₹100,000 - ₹500,000</MenuItem>
          <MenuItem value="500000-1000000">₹500,000 - ₹1,000,000</MenuItem>
          <MenuItem value="1000000+">Above ₹1,000,000</MenuItem>
        </Select>
      </FormControl>

      {/* Sort By Filter */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Sort By</InputLabel>
        <Select
          value={filters.sortBy}
          label="Sort By"
          onChange={e => handleFilterChange("sortBy", e.target.value)}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E5E7EB",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5652B0",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#5652B0",
            },
          }}>
          <MenuItem value="">None</MenuItem>
          <MenuItem value="firmName_asc">Firm Name (A-Z)</MenuItem>
          <MenuItem value="firmName_desc">Firm Name (Z-A)</MenuItem>
          <MenuItem value="creditLimit_asc">Credit Limit (Low-High)</MenuItem>
          <MenuItem value="creditLimit_desc">Credit Limit (High-Low)</MenuItem>
          <MenuItem value="dateCreated_desc">Newest First</MenuItem>
          <MenuItem value="dateCreated_asc">Oldest First</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default CategoryHeader;
